import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

export const searchGdprDeletions = async (token, searchValue, searchType = 'all') => {
  log("welcome in searchGdprDeletions")
  const API_URL = `${BASE_URL}/home/gdpr_search_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const params = {
      type: searchType,
      value: searchValue
    }

    const result = await axios.get(API_URL, { headers, params })
    log("searchGdprDeletions result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in searchGdprDeletions:")
    log(err)
    return { error: true, message: err.message }
  }
}

export default { searchGdprDeletions }
